import { authProvider } from "../auth/authProvider";

export interface Project {
  name: string;
  status: "ENABLED" | "DISABLED";
}

export interface ProjectsResponse {
  projects: Project[];
}

const apiUrl = `${process.env.REACT_APP_BASE_URL}/dashboard/projects`;

export async function getProjects(): Promise<ProjectsResponse> {
  return await authProvider.fetch(apiUrl);
}
